var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "w-100 h-100", attrs: { id: "login" } }, [
    _vm.passwordlessLoginToken && !_vm.passwordlessLoginUnsuccessful
      ? _c("div", { staticClass: "loading-spinner" })
      : _c(
          "div",
          { staticClass: "d-flex justify-center justify-content-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "content d-flex flex-column justify-content-center align-items-center content-wrapper",
              },
              [
                _c("div", { staticClass: "content-form" }, [
                  _c(
                    "div",
                    { staticClass: "header-container" },
                    [
                      _c("img", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          src: "https://static.supsis.live/common/supsisAiLogo.png",
                        },
                      }),
                      _vm._v(" "),
                      _c("language-switch", { attrs: { id: "selectLang" } }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "login-title" }, [
                    _c("div", { staticClass: "title-text" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("login.loginTitle1")) +
                          "\n                        "
                      ),
                      _c("div", [_vm._v(_vm._s(_vm.$t("login.loginTitle2")))]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "margin-top": "40px" } }, [
                    _c("div", [
                      _c(
                        "span",
                        {
                          staticClass: "font-weight-bold email",
                          staticStyle: { color: "#183b56" },
                        },
                        [_vm._v(_vm._s(_vm.$t("login.email")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "margin-top": "3px" } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                "has-feedback": "",
                                "validate-status": _vm.loginForm.email
                                  ? !!_vm.errors.first("email")
                                    ? "error"
                                    : "success"
                                  : undefined,
                                help:
                                  _vm.loginForm.email &&
                                  _vm.errors.first("email")
                                    ? _vm.$t("login.emailError")
                                    : undefined,
                              },
                            },
                            [
                              _c(
                                "a-input",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|email",
                                      expression: "'required|email'",
                                    },
                                  ],
                                  ref: "userNameInput",
                                  class: { error: !!_vm.errors.first("email") },
                                  attrs: {
                                    name: "email",
                                    placeholder: _vm.$t(
                                      "login.emailPlaceholder"
                                    ),
                                  },
                                  on: {
                                    keydown: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.doLogin()
                                    },
                                  },
                                  model: {
                                    value: _vm.loginForm.email,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.loginForm, "email", $$v)
                                    },
                                    expression: "loginForm.email",
                                  },
                                },
                                [
                                  _c("a-icon", {
                                    attrs: {
                                      slot: "prefix",
                                      type: "mail",
                                      id: "mailIcon",
                                    },
                                    slot: "prefix",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-top": "15px" } }, [
                      _c(
                        "span",
                        {
                          staticClass: "font-weight-bold",
                          staticStyle: { color: "#183b56" },
                        },
                        [_vm._v(_vm._s(_vm.$t("login.password")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "margin-top": "3px" } },
                        [
                          _c(
                            "a-input",
                            {
                              ref: "userNameInput",
                              attrs: {
                                type: _vm.loginForm.hidePassword
                                  ? "text"
                                  : "password",
                                placeholder: _vm.$t(
                                  "login.passwordPlaceholder"
                                ),
                              },
                              on: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.doLogin()
                                },
                              },
                              model: {
                                value: _vm.loginForm.password,
                                callback: function ($$v) {
                                  _vm.$set(_vm.loginForm, "password", $$v)
                                },
                                expression: "loginForm.password",
                              },
                            },
                            [
                              _c("a-icon", {
                                attrs: { slot: "prefix", type: "lock" },
                                slot: "prefix",
                              }),
                              _vm._v(" "),
                              _c("a-icon", {
                                staticStyle: { color: "rgba(0, 0, 0, 0.45)" },
                                attrs: {
                                  slot: "suffix",
                                  type: _vm.loginForm.hidePassword
                                    ? "eye"
                                    : "eye-invisible",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.loginForm.hidePassword =
                                      !_vm.loginForm.hidePassword
                                  },
                                },
                                slot: "suffix",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "user-hash d-flex justify-content-between flex-wrap",
                        staticStyle: { "margin-top": "15px" },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "a-checkbox",
                              {
                                on: { change: _vm.$_.noop },
                                model: {
                                  value: _vm.loginForm.rememberme,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.loginForm, "rememberme", $$v)
                                  },
                                  expression: "loginForm.rememberme",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("login.loginMemory")) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          { attrs: { to: "/forgot-password" } },
                          [
                            _c("div", { staticStyle: { color: "#ec4b1d" } }, [
                              _vm._v(_vm._s(_vm.$t("login.passwordForget"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "d-flex justify-content-between",
                        staticStyle: { "margin-top": "20px" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "w-100 text-center text-white font-weight-bold user-select-none",
                            staticStyle: {
                              "border-radius": "8px",
                              padding: "13px 0",
                              "font-size": "15px",
                            },
                            style: {
                              background:
                                !_vm.errors.first("email") &&
                                _vm.loginForm.password
                                  ? "#ec4b1d"
                                  : "#C3CAD9",
                              cursor:
                                !_vm.errors.first("email") &&
                                _vm.loginForm.password
                                  ? "pointer"
                                  : null,
                            },
                            on: {
                              click: function ($event) {
                                !_vm.errors.first("email") &&
                                _vm.loginForm.password
                                  ? _vm.doLogin()
                                  : null
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("login.login")) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center",
                        staticStyle: { "margin-top": "20px" },
                      },
                      [
                        _c("hr", { attrs: { color: "#C3CAD9", width: "25%" } }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              margin: "0px 5px",
                              color: "#183b56",
                            },
                            attrs: { width: "100%" },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("login.loginFooter")) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("hr", { attrs: { color: "#C3CAD9", width: "25%" } }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "20px",
                          display: "flex",
                          "justify-content": "space-between",
                          width: "100%",
                        },
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "text-center text-white w-100 font-weight-bold",
                            staticStyle: {
                              background: "#183b56",
                              "border-radius": "8px",
                              padding: "13px 0",
                              "font-size": "15px",
                            },
                            attrs: { to: "/passwordless-login" },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("login.emailLogin")) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }